export const GOOGLE_LOGIN = "GOOGLE_LOGIN";
export const EMAIL_LOGIN = "EMAIL_LOGIN";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const VERIFY_LOGIN = "VERIFY_LOGIN";

export const USER_LIST = "USER_LIST";
export const ADD_USER = "ADD_USER";
export const USER_EDIT = "USER_EDIT";
export const USER_DELETE = "USER_DELETE";
export const USER_VIEW = "USER_VIEW";
export const USER_STATUS = "USER_STATUS";
export const UPLOAD_CSV_FILE = "UPLOAD_CSV_FILE";
export const UPLOAD_USERS = "UPLOAD_USERS";

export const TEAM_LIST = "TEAM_LIST";
export const ADD_TEAM = "ADD_TEAM";
export const USERS_DROPDOWN = "USERS_DROPDOWN";
export const TL_DROPDOWN = "TL_DROPDOWN";
export const TEAM_VIEW = "TEAM_VIEW";
export const TEAM_DELETE = "TEAM_DELETE";
export const TEAM_EDIT = "TEAM_EDIT";
export const TEAM_USER_DELETE = "TEAM_USER_DELETE";
export const ADD_TEAM_USER = "ADD_TEAM_USER";

export const FOLDER_LIST = "FOLDER_LIST";
export const ADD_FOLDER = "ADD_FOLDER";
export const FOLDER_EDIT = "FOLDER_EDIT";
export const FOLDER_DELETE = "FOLDER_DELETE";
export const FOLDER_VIEW = "FOLDER_VIEW";

export const DOCUMENTS_LIST = "DOCUMENTS_LIST";
export const ADD_DOCUMENTS = "ADD_DOCUMENTS";
export const DOCUMENTS_EDIT = "DOCUMENTS_EDIT";
export const DOCUMENTS_DELETE = "DOCUMENTS_DELETE";
export const DOCUMENTS_VIEW = "DOCUMENTS_VIEW";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const FOLDERS_LIST = "FOLDERS_LIST";
export const TEAMS_DROP_DOWN = "TEAMS_DROP_DOWN"
export const ASSIGN_TEAM = "ASSIGN_TEAM";
export const ASSIGN_USER = "ASSIGN_USER";
export const USERS_DROP_DOWN = "USERS_DROP_DOWN";
export const GET_DOCUMENT_SUMMARY = "GET_DOCUMENT_SUMMARY";
export const TRANSLATE_SUMMARY = "TRANSLATE_SUMMARY"

export const GLOSSARY_LIST = "GLOSSARY_LIST";
export const ADD_GLOSSARY = "ADD_GLOSSARY";
export const DELETE_GLOSSARY = "DELETE_GLOSSARY";
export const UPLOAD_GLOSSARY_FILE = "UPLOAD_GLOSSARY_FILE";

export const TM_LIST = "TM_LIST";
export const TM_UPDATE = 'TM_UPDATE';
export const TM_DELETE = 'TM_DELETE';
export const TM_EXPORT = 'TM_EXPORT';
export const TM_ENABLE_DISABLE = 'TM_ENABLE_DISABLE';

export const GLOSSARY_DROP_DOWN = "GLOSSARY_DROP_DOWN";
export const DOCUMENTS_DROP_DOWN = "DOCUMENTS_DROP_DOWN";
export const GET_SIGNED_URL = 'GET_SIGNED_URL';
export const TRANSLATE_DOCUMENT = 'TRANSLATE_DOCUMENT';
export const TRANSLATION_JOBS = 'TRANSLATION_JOBS';
export const TRANSLATION_JOBS_VIEW = 'TRANSLATION_JOBS_VIEW';
export const PUBLISH_DOC = "PUBLISH_DOC";
export const SEND_POST_EDITING = 'SEND_POST_EDITING';

export const LIST_POST_EDITING = "LIST_POST_EDITING"
export const POST_EDIT_WORD = "POST_EDIT_WORD";
export const COMPLETE_REVIEW = "COMPLETE_REVIEW";

export const WORD_TEXT_BLOCKS = "WORD_TEXT_BLOCKS";
export const PPTX_TEXT_BLOCKS = "PPTX_TEXT_BLOCKS";
export const PDF_TEXT_BLOCKS = "PDF_TEXT_BLOCKS";
export const HTML_TEXT_BLOCKS = "HTML_TEXT_BLOCKS";

export const UPDATE_WORD_DOCUMENT = "UPDATE_WORD_DOCUMENT";
export const UPDATE_PPTX_DOCUMENT = "UPDATE_PPTX_DOCUMENT";
export const UPDATE_PDF_DOCUMENT = "UPDATE_PDF_DOCUMENT";
export const UPDATE_HTML_DOCUMENT = "UPDATE_HTML_DOCUMENT";


export const VIEW_DOCUMENT = "VIEW_DOCUMENT"

export const COMPANY_REGISTER = "COMPANY_REGISTER";
export const PROFILE_VIEW = "PROFILE_VIEW";

export const SEND_TO_MODEL = "SEND_TO_MODEL";
export const GET_DRAFTED_DETAILS = "GET_DRAFTED_DETAILS";

export const TRANSLATE_HTML_FILE = "TRANSLATE_HTML_FILE";
export const TRANSLATE_MORE_PAGES = 'TRANSLATE_MORE_PAGES';

export const UPDATE_POST_EDIT_JOB = "UPDATE_POST_EDIT_JOB";
export const TRANSLATE_FILE = 'TRANSLATE_FILE'

export const SYSTEM_LOGS_LIST = "SYSTEM_LOGS_LIST";
